(function() {
  function initCollectionTabs(sectionId) {
    const section = document.getElementById('CollectionTabsSection-' + sectionId);
    if (!section) return;

    // Guards against double-binding when this script is included by more than one
    // section type on the same page (e.g. Collection Tabs + TOF Product Carousel) —
    // without it, a second <script> tag re-running this function would attach a
    // second Add to Cart submit handler and double-add the item on one click.
    if (section.dataset.ctInitialized) return;
    section.dataset.ctInitialized = 'true';

    const tabs = section.querySelectorAll('.collection-tab');
    const containers = section.querySelectorAll('.collection-products-container');

    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        if (this.classList.contains('active')) return;
        
        const collectionId = this.dataset.collectionId;
        const targetContainer = section.querySelector(`.collection-products-container[data-collection-id="${collectionId}"]`);

        if (!targetContainer) return;

        tabs.forEach(t => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        
        containers.forEach(c => {
          c.classList.remove('active');
        });

        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');
        targetContainer.classList.add('active');

        this.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      });
    });

    function initColorSwatches(section) {
      const colorSwatchContainers = section.querySelectorAll('.collection-product-color-swatches');
      
      colorSwatchContainers.forEach(container => {
        const productId = container.dataset.productId;
        const swatches = container.querySelectorAll('.collection-color-swatch');
        
        swatches.forEach(swatch => {
          swatch.addEventListener('click', function() {
            const variantId = this.dataset.variantId;
            const price = parseInt(this.dataset.price);
            const comparePrice = parseInt(this.dataset.comparePrice) || 0;
            const imageUrl = this.dataset.imageUrl;
            const inventoryQuantity = parseInt(this.dataset.inventoryQuantity) || 0;
            const inventoryManagement = this.dataset.inventoryManagement || '';
            const inventoryPolicy = this.dataset.inventoryPolicy || '';
            
            swatches.forEach(s => s.classList.remove('active'));
            this.classList.add('active');
            
            const variantInput = section.querySelector(`input[data-variant-input="${productId}"]`);
            if (variantInput) {
              variantInput.value = variantId;
            }
            
            if (imageUrl) {
              const productImage = section.querySelector(`img[data-product-image="${productId}"]`);
              if (productImage) {
                productImage.src = imageUrl;
                productImage.srcset = imageUrl.replace('320x320', '640x640') + ' 2x';
              }
            }
            
            const variant = {
              id: variantId,
              price: price,
              compare_at_price: comparePrice
            };
            updateProductPrice(section, productId, variant);
            

            updateButtonState(section, productId, inventoryQuantity, inventoryManagement, inventoryPolicy);
          });
        });
      });
    }
    
    function updateButtonState(section, productId, inventoryQuantity, inventoryManagement, inventoryPolicy) {
      const button = section.querySelector(`button[data-product-button="${productId}"]`);
      if (!button) return;

      const isOutOfStock = inventoryManagement === 'shopify' && 
                           inventoryQuantity < 1 && 
                           inventoryPolicy === 'deny';

      const isPreOrder = inventoryManagement === 'shopify' && 
                         inventoryQuantity < 1 && 
                         inventoryPolicy !== 'deny';
      
      if (isOutOfStock) {
        button.disabled = true;
        button.textContent = button.dataset.soldOutText || 'Out Of Stock';
      } else if (isPreOrder) {
        button.disabled = false;
        button.textContent = button.dataset.preorderText || 'Pre-order';
      } else {
        button.disabled = false;
        button.textContent = button.dataset.defaultText || 'Add to cart';
      }
    }
    
    function updateProductPrice(section, productId, variant) {
      const priceEl = section.querySelector(`.collection-product-price[data-product-price="${productId}"]`);
      const comparePriceEl = section.querySelector(`.collection-product-compare-price[data-product-compare-price="${productId}"]`);
      
      const formatMoney = function(cents) {
        if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
          return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
        }
        return '$' + (cents / 100).toFixed(2);
      };
      
      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }
      
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
    }
    
    initColorSwatches(section);

    const forms = section.querySelectorAll('.collection-product-form');
    forms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const addButton = this.querySelector('.collection-product-add-to-cart');
        
        if (addButton.disabled) {
          return;
        }
        
        const formData = new FormData(this);
        const originalText = addButton.textContent;

        addButton.disabled = true;

        const cartAddUrl = (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js';
        
        fetch(cartAddUrl, {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(item => {
          if (item.status === 422) {
            addButton.textContent = originalText;
            addButton.disabled = false;
            alert(item.description || addButton.dataset.errorText || 'Error adding to cart');
            return;
          }
          
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          
          setTimeout(() => {
            addButton.textContent = originalText;
            addButton.disabled = false;
          }, 1500);
        })
        .catch(error => {
          console.error('Error:', error);
          addButton.textContent = originalText;
          addButton.disabled = false;
          alert(addButton.dataset.errorText || 'Error adding to cart');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      const sections = document.querySelectorAll('[data-collection-tabs-section-id]');
      sections.forEach(section => {
        const sectionId = section.dataset.collectionTabsSectionId;
        initCollectionTabs(sectionId);
      });
    });
  } else {
    const sections = document.querySelectorAll('[data-collection-tabs-section-id]');
    sections.forEach(section => {
      const sectionId = section.dataset.collectionTabsSectionId;
      initCollectionTabs(sectionId);
    });
  }
})();

